import type { RouteObject } from 'react-router-dom';

import { SIGNUP_ROUTES } from '@/config/constants';
import { AccountLocked } from '@/pages/SignUpContainer/AccountLocked';
import { ActivationSuccess } from '@/pages/SignUpContainer/ActivationSuccess';
import { ExpiredLinkWrapper } from '@/pages/SignUpContainer/ExpiredLinkWrapper';
import { ExpiredPasswordLink } from '@/pages/SignUpContainer/ExpiredPasswordLink';
import { ForgotPassword } from '@/pages/SignUpContainer/ForgotPassword';
import { PasswordChangeSuccess } from '@/pages/SignUpContainer/PasswordChangeSuccess';
import { RegistrationSuccess } from '@/pages/SignUpContainer/RegiStrationSuccess';
import { ResetLink } from '@/pages/SignUpContainer/ResetLink';
import { SetPassword } from '@/pages/SignUpContainer/SetPassword';
import { SignUp } from '@/pages/SignUpContainer/Signup';
// import { ExpiredActivationLink } from '@/pages/SignUpContainer/ExpiredActivationLink';
import { WarningActivation } from '@/pages/SignUpContainer/WarningActivation';
const SHOW_SIGNUP = process.env?.VITE_ENVIRONMENT === 'onprem';
export const signUpRoutes: RouteObject[] = [
  ...(SHOW_SIGNUP
    ? [
        {
          path: SIGNUP_ROUTES.SIGNUP,
          element: <SignUp />,
        },
      ]
    : []),
  {
    path: SIGNUP_ROUTES.REG_SUCCESS,
    element: <RegistrationSuccess />,
  },
  {
    path: SIGNUP_ROUTES.ACTIVATION_SUCCESS,
    element: <ActivationSuccess />,
  },
  {
    path: SIGNUP_ROUTES.FORGOTPASSWORD,
    element: <ForgotPassword />,
  },
  {
    path: SIGNUP_ROUTES.RESETLINK,
    element: <ResetLink />,
  },
  {
    path: SIGNUP_ROUTES.SETPASSWORD,
    element: <SetPassword />,
  },
  {
    path: SIGNUP_ROUTES.PASSWORDCHANGESUCCESS,
    element: <PasswordChangeSuccess />,
  },
  {
    path: SIGNUP_ROUTES.LINK_EXPIRED_SIGNIN,
    element: <ExpiredLinkWrapper />,
  },
  {
    path: SIGNUP_ROUTES.LINK_EXPIRED_PASSWORD,
    element: <ExpiredPasswordLink />,
  },
  {
    path: SIGNUP_ROUTES.WARNING_ACTIVATION,
    element: <WarningActivation />,
  },
  {
    path: SIGNUP_ROUTES.ACCOUNT_LOCKED,
    element: <AccountLocked />,
  },
];

export default signUpRoutes;
